<template>
  <div class="hide-response">
    <div class="hide-response__wrap">
      <div class="hide-response__content">
        <div class="hide-response__question" v-if="hide && !sent">
          <div class="hide-response__title" v-html="">
            {{ $tr('response.hide.text.question') }}
          </div>
          <div
            class="hide-response__text"
            v-html="$tr('response.hide.text.content')"
          ></div>

          <div class="hide-response__btn">
            <vbutton
              label="response.hide.text.btn"
              :loading="loading"
              @click="set_visibility(false)"
            />
          </div>
        </div>

        <div class="hide-response__answer" v-else-if="sent">
          <img src="/static/images/elements/icon_ok.png" />
          <div class="hide-response__title">{{ title }}</div>
          <div class="hide-response__text">{{ text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'interview-visibility',

    props: ['token'],

    data() {
      return {
        sent: false
      };
    },

    created() {
      this.load();
      if (this.open) {
        this.set_visibility(true);
      }
    },

    computed: {
      hide() {
        return this.$route.name === 'interview-hide';
      },
      open() {
        return this.$route.name === 'interview-open';
      },
      loading() {
        return this.$store.getters['interview/visibility/loaded'];
      },
      interview() {
        return this.$store.getters['interview/visibility/item'];
      },
      visibility() {
        return this.$store.getters['interview/visibility/visibility'];
      },
      change_count() {
        return this.visibility ? this.visibility.change_count : null;
      },
      title() {
        if (this.hide) {
          return this.$tr('response.hide.text.interview_hide');
        } else {
          return this.$tr('response.hide.text.interview_show');
        }
      },
      text() {
        if (this.hide) {
          return this.$tr('response.hide.text.interview_hideText');
        } else {
          return this.$tr('response.hide.text.interview_showText');
        }
      }
    },

    methods: {
      load() {
        this.$store.dispatch('interview/visibility/load', this.token);
      },
      set_visibility(val) {
        this.$store
          .dispatch('interview/visibility/set_visibility', {
            interview_token: this.token,
            status: val
          })
          .then(() => (this.sent = true));
      }
    }
  };
</script>

<style lang="scss" scoped>
  .hide-response {
    position: relative;
    min-height: calc(100vh - 90px);

    &__wrap {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 800px;
      height: 424px;
      background: #ffffff;
      box-shadow: 0px 1px 40px rgba(28, 50, 75, 0.05);
      border-radius: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__content {
      max-width: 500px;
      color: #233346;
      text-align: center;
    }

    &__title {
      font-style: normal;
      font-weight: 500;
      font-size: 28px;
      line-height: 41px;
      margin-top: 20px;
    }

    &__text {
      font-size: 15px;
      margin: 14px 0 24px;
    }

    &__select .multiselect {
      width: 280px;
      max-width: 280px;
      margin: 0 auto;
    }

    &__btn {
      margin-top: 30px;
    }
  }
</style>
